import React from "react";
import ReactDOM from "react-dom";
import { MonetaryAmount } from "../../app/domain/monetary-amount";
import { findCompanyMovements } from "../../infrastructure/repository/movements-repository";
import { findCompanyDetail } from "../../infrastructure/repository/company-repository";
import {
  translate,
  getLanguage,
} from "../../infrastructure/translate/localization";
import { logError, addContextLog } from "../../infrastructure/log";
import { checkBalance } from "./check-balance";

import { showErrorMessage } from "../commons/show-error-message";
import BalanceSection from "./components/BalanceSection";
import showAlertThresholdModal from "./showAlertThresholdModal";

export function renderBalanceSection(
  { company, prediction, blocked, balance } = {
    company: undefined,
    prediction: undefined,
    blocked: undefined,
    balance: undefined,
  }
) {
  const langTag = getLanguage();
  let formattedBalance = MonetaryAmount.ZERO;
  let predictionBalance = MonetaryAmount.ZERO;
  let blockedBalance = MonetaryAmount.ZERO;

  if (balance?.final) {
    formattedBalance = formattedBalance.add(balance.final);
  }

  if (prediction) {
    const accumulatedMeal =
      prediction.predictiveAccumulated.predictiveMealAccumulated;
    const accumulatedTransport =
      prediction.predictiveAccumulated.predictiveTransportAccumulated;
    const subsidy = prediction.predictiveSubsidy;
    predictionBalance = predictionBalance
      .add(accumulatedMeal)
      .add(accumulatedTransport)
      .add(subsidy);
  }

  if (blocked) {
    blockedBalance = formattedBalance.subtract(blockedBalance.add(blocked));
  }

  const target = document.getElementById("balance-section-container");

  if (target) {
    ReactDOM.render(
      <BalanceSection
        loaded={!!company}
        balance={formattedBalance.prettifyMoney({ langTag })}
        autoClose={company ? company.autoCloseDay : ""}
        prediction={
          predictionBalance.greaterThan(MonetaryAmount.ZERO)
            ? predictionBalance.prettifyMoney({ langTag })
            : undefined
        }
        blockedBalance={
          blockedBalance.equal(MonetaryAmount.ZERO)
            ? blockedBalance.prettifyMoney({ langTag })
            : undefined
        }
        accountId={company ? company.accountId : ""}
        alertThreshold={
          company?.alertThreshold
            ? company.alertThreshold.amountInCents / 100
            : undefined
        }
        alertThresholdEmails={company?.alertThresholdEmails || []}
      />,
      target
    );
  }
}

export async function displayBalance() {
  renderBalanceSection();
  try {
    const { data: company } = await findCompanyDetail();
    addContextLog("info", "displayBalance", "display-screen", { company });
    const response = await findCompanyMovements({ companyId: company.id });
    const { data: balanceMovement } = response;
    const { predictiveBalance, blockedBalance } = await checkBalance();
    renderBalanceSection({
      company,
      prediction: predictiveBalance,
      blocked: blockedBalance,
      balance: balanceMovement.movements[0],
    });
    if (
      MonetaryAmount.ofCurrency(company.alertThreshold).equal(
        MonetaryAmount.ZERO
      )
    ) {
      showAlertThresholdModal();
    }
  } catch (e) {
    logError(e, `Error to displayBalance`);
    showErrorMessage(translate("common-messages.basic-error-message"), true);
  }
}
